<script setup lang="ts">
defineProps<{
  type: 'plus' | 'minus'
  disabled?: boolean
  mark?: boolean
  size: 's' | 'm' | 'l'
}>()
</script>

<template>
  <button type="button" :aria-label="type === 'plus' ? 'Increase' : 'Decrease'" :disabled :class="[$style.add, size, { mark }]">
    <slot>
      <span :class="type === 'plus' ? $style.plus : $style.minus" />
    </slot>
  </button>
</template>

<style module>
.add {
  composes: global(_relative);
  cursor: pointer;
  outline: none;

  composes: global(_ctr);

  composes: global(_br99);

  border: none;
  composes: global(_fw-xl);

  width: var(--size, 36px);
  height: var(--size, 36px);

  composes: global(_fs08);
  composes: global(_fw-xxl);
  composes: global(_c2);
}
.add:not(:disabled):hover {
  color: var(--black);
}

.add svg {
  height: 14px;
  width: 14px;
  color: inherit;
}

.add:disabled {
  cursor: not-allowed;
  color: var(--black-4);
}

.add:not(:disabled):hover,
.add:global(.mark):not(:disabled) {
  background: var(--black-5);
}
.add:global(.mark):not(:disabled):hover {
  background: var(--black-6);
}

.add:not(:disabled):active {
  box-shadow: 0 0 0 2px var(--blue7);
}

.icon {
  composes: global(_relative);
  composes: global(_h100p);
  composes: global(_block);
  transition: transform 150ms ease;
}
.add:active .icon {
  transform: scale(0.8);
}
.add:hover .icon {
  transform: scale(1);
}
.plus {
  composes: icon;
  width: 10px;
}
.minus {
  composes: icon;
  width: 8px;
}
.plus::before,
.plus::after,
.minus::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 2px;
  margin: auto;
  content: '';
  background: currentColor;
}
.plus::after {
  transform: rotate(90deg);
}
</style>
